const tokenKey = 'SPO_API_TOKEN';
const tokenRefreshKey = 'SPO_API_TOKEN_REFRESH';
const tokenExpirationKey = 'SPO_API_TOKEN_EXPIRATION';
const loginTimeKey = 'SPO_LOGIN_TIME';

export const storeToken = (token) => window.localStorage.setItem(tokenKey, token);
export const storeRefreshToken = (token) => window.localStorage.setItem(tokenRefreshKey, token);
export const storeTokenExpiration = (expiration) => window.localStorage.setItem(tokenExpirationKey, expiration);
export const storeLoginTime = (time) => window.localStorage.setItem(loginTimeKey, time);
export const clearToken = () => window.localStorage.removeItem(tokenKey);
export const clearTokenExpiration = () => window.localStorage.removeItem(tokenExpirationKey);
export const clearRefreshToken = () => window.localStorage.removeItem(tokenRefreshKey);
export const clearLoginTime = () => window.localStorage.removeItem(loginTimeKey);
export const getToken = () => window.localStorage.getItem(tokenKey);
export const getRefreshToken = () => window.localStorage.getItem(tokenRefreshKey);
export const getTokenExpiration = () => window.localStorage.getItem(tokenExpirationKey);
export const getLoginTime = () => window.localStorage.getItem(loginTimeKey);

const methodKey = 'SPO_LOGIN_METHOD';

export const storeLoginMethod = (method) => window.localStorage.setItem(methodKey, method);
export const clearLoginMethod = () => window.localStorage.removeItem(methodKey);
export const getLoginMethod = () => window.localStorage.getItem(methodKey);
